import React from 'react'

export default function Tag({children, color = 'gray', onRemove}) {
  const map = {
    '#ff5000': {bg: '#FFF3EF', text: '#ff5000', border: '#FFD0BF'},
    blue: {bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE'},
    gray: {bg: '#F3F4F6', text: '#374151', border: '#E5E7EB'},
  }
  const c = map[color] || map.gray

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        background: c.bg,
        color: c.text,
        border: `1px solid ${c.border}`,
        borderRadius: 99,
        fontSize: 11,
        fontWeight: 500,
        padding: '2px 7px',
      }}
    >
      {children}
      {onRemove && (
        <span onClick={onRemove} style={{cursor: 'pointer', fontSize: 12}}>
          ×
        </span>
      )}
    </span>
  )
}
